/* ==========================================================================
   ATÖLYE — giriş perdesi denetimi

   Tasarım kararları:
   - Zaman çizelgesinin TEK kaynağı CSS. Süreler --out-in / --out-dur özel
     niteliklerinden okunur; burada tekrar yazılmaz. Böylece koreografi
     CSS'te değişince JS kendiliğinden uyar.
   - Kütüphane yok. Perde LCP'den önce çalışır; oraya GSAP koymak
     lüksün bedelini kullanıcıya ödetmek olur.
   - Fail-open: JS patlarsa perde açılmaz, site normal görünür.
     (Bunun tersi — perdenin ekranda kalması — dükkânı kapatmak demek.)
   ========================================================================== */

(() => {
  const SEL = "[data-atl-intro]";

  /** Özel nitelikten milisaniye okur: "4200ms" | "4.2s" -> 4200 */
  const ms = (el, prop, fallback) => {
    const raw = getComputedStyle(el).getPropertyValue(prop).trim();
    if (!raw) return fallback;
    const n = parseFloat(raw);
    if (Number.isNaN(n)) return fallback;
    return raw.endsWith("ms") ? n : n * 1000;
  };

  /** Depolama özel sekmede patlar; yazamamak perdeyi bozmamalı. */
  const remember = () => {
    try {
      window.sessionStorage.setItem("atl-intro-seen", "1");
    } catch {
      /* özel sekme — perde her yüklemede oynar, kabul edilebilir */
    }
  };

  const init = (el) => {
    if (el.dataset.atlReady === "1") return;
    el.dataset.atlReady = "1";

    // Tema düzenleyici istisnası: Shopify bölümü yeniden yüklerken HTML'i
    // innerHTML ile basar, bu yüzden bölümün satır içi betiği İKİNCİ kez
    // çalışmaz ve işaret gelmez. Satıcı ayarı değiştirip perdeyi göremezse
    // bölüm kullanılamaz hale gelir — burada bilerek biz işaretliyoruz.
    if (window.Shopify && window.Shopify.designMode && el.dataset.atlPlay !== "1") {
      el.dataset.atlPlay = "1";
      el.hidden = false;
      document.documentElement.classList.add("atl-intro-open");
    }

    // Gerçek ziyaretçi için karar boyamadan önce satır içi betikte verildi.
    // Burada tekrar vermiyoruz; yalnızca işarete bakıyoruz.
    if (el.dataset.atlPlay !== "1") {
      el.remove();
      document.documentElement.classList.remove("atl-intro-open");
      return;
    }

    const root = document.documentElement;
    const skip = el.querySelector("[data-atl-skip]");
    const outAt = ms(el, "--out-in", 4200);
    const outDur = ms(el, "--out-dur", 800);

    let timer = null;
    let closed = false;

    const finish = () => {
      el.remove();
      root.classList.remove("atl-intro-open");
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("wheel", close, { passive: true });
      window.removeEventListener("touchstart", close, { passive: true });
    };

    const close = () => {
      if (closed) return;
      closed = true;
      clearTimeout(timer);
      remember();

      // Odağı perdeden çıkar; yoksa kaldırılan düğmede kalır ve odak kaybolur.
      if (skip && document.activeElement === skip) skip.blur();

      el.classList.add("is-leaving");
      // Perde animasyonu bitmezse (sekme arkada, animasyon iptal) yine de temizle.
      const guard = setTimeout(finish, outDur + 400);
      el.addEventListener(
        "animationend",
        (event) => {
          if (event.target !== el) return;
          clearTimeout(guard);
          finish();
        },
        { once: true }
      );
    };

    const onKey = (event) => {
      if (event.key === "Escape" || event.key === "Enter" || event.key === " ") close();
    };

    root.classList.add("atl-intro-open");
    el.hidden = false;

    if (skip) {
      skip.addEventListener("click", close);
      // Klavye kullanıcısı ilk Tab'da çıkışı bulsun.
      skip.focus({ preventScroll: true });
    }
    document.addEventListener("keydown", onKey);
    window.addEventListener("wheel", close, { passive: true });
    window.addEventListener("touchstart", close, { passive: true });

    timer = setTimeout(close, outAt);
  };

  const boot = () => document.querySelectorAll(SEL).forEach(init);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Tema düzenleyici bölümü yeniden yüklediğinde tekrar kur.
  document.addEventListener("shopify:section:load", (event) => {
    const el = event.target.querySelector ? event.target.querySelector(SEL) : null;
    if (el) init(el);
  });
})();
